import { useT } from "../i18n";

export const Marquee = () => {
  const t = useT();
  const items = [...t.marquee_items, ...t.marquee_items];

  return (
    <div className="bg-bergamote-600 text-cream-50 py-4 overflow-hidden border-y border-bergamote-700/40" data-testid="editorial-marquee">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif italic text-lg sm:text-xl px-6">{item}</span>
            <span className="text-saffron-500 text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
